import React, { useState,useEffect } from "react";
import {Box,
    Flex,
    Image} from "@chakra-ui/react";
import { isAndroid, isIOS } from "react-device-detect";
import { useSearchParams } from "react-router-dom";


function Coupon() {
    const Basic_key = 'Basic Sm51ZXRWWUkxc1Y5c01wNDl6WjZOeDB0WUhBSTJ1WlE6RCpHLUthUGRTZ1ZrWXAzczZ2OXkvQj9FKEgrTWJRZVRoV21acTR0N3cheiVDJkYpSkBOY1JmVWpYbjJyNXU4eC9BP0QoRy1LYVBkU2dWa1lwM3M2djl5JEImRSlIQE1iUWVUaFdtWnE0dDd3IXolQypGLUphTmRSZlVqWG4ycjU='
    const [searchParams, setSearchParams] = useSearchParams(window.location.hash);
    const [device, setdevice] = useState(null);
    const [campaign, setcampaign] = useState(null);
    const param = searchParams.get('campaign');
    if (param) {
        localStorage.setItem('campaign',param)
    }
    useEffect(async () => {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", Basic_key);
        var requestOptions = {
            method: 'GET',
            //credentials: 'include',
            headers: myHeaders,
            redirect: 'follow'
        };

        await fetch("https://prod.truelivingtech.com/rest/coupon/" + param, requestOptions)
        .then(response => response.json())
        .then(data => { 
            if (data.status === "ok") {
                if (isAndroid) {
                    setcampaign(param)
                    setdevice("android")
                    window.location.replace(`trueidapp://jumpRedeem?campaign=${param}`)
                      
                 } else if (isIOS) {
                    setcampaign(param)
                    setdevice("IOS")
                    //window.location = `trueidapp://`
                    window.location.replace(`trueidapp://jumpRedeem?campaign=${param}`)
          
                 } else {
                    setcampaign(param)
                    setdevice("web")
                     
                     //window.location.replace("https://truehealth.truedigital.com/mordeeapp-livingtech");
                 }
            } else {
                alert("The specified campaign does not exist")
            }
            
        })
        .catch(error => { alert("The specified campaign does not exist")});
        
    }, []);
                
    return (
        <>

            <p>{campaign}</p>

         
        </>
    );
}

export default Coupon;
